import { z } from "zod/v3";

export const Licence = z.object({
	id: z.string().nullish(),
	name: z.string().nullish(),
	range: z.string().nullish(),
	features: z.array(z.string()).nullish(),
});
export type Licence = z.infer<typeof Licence>;

export type MeasurementSettings = z.infer<typeof MeasurementSettings>;

export const MeasurementSettings = z.object({
	temp: z.enum(["c", "f"]),
	depth: z.enum(["m", "ft"]),
	weight: z.enum(["kg", "lbs"]),
});

export const Profile = z.object({
	id: z.string(),
	name: z.string().nullable(),
	firstName: z.string(),
	lastName: z.string().nullable(),
	email: z.string(),
	image: z.string().nullable(),
	created: z.coerce.date(),
	// linkedAccounts: z.array(z.any()),
	licence: Licence.nullish(),
	licences: z.array(z.object({ licence: Licence })),
	registrationStatus: z.enum(["OnBoarding", "Complete"]).nullable().optional(),
	settings: z.union([
		z.record(z.union([z.boolean(), z.record(z.boolean())])),
		z.object({
			value: z.record(z.union([z.boolean(), z.record(z.boolean())])),
		}),
	]),
	measurementSettings: MeasurementSettings.optional(),

	canAddComp: z.boolean().optional().nullable(),
	competitionCredits: z.number().optional().nullable(),
	home: z.string().nullish(),

	dateOfBirth: z.coerce.date().nullable(),
	photo: z.any().nullable(),
	nationality: z.string().nullable(),

	requiresRedirect: z.boolean().nullish(),
	redirectUrl: z.string().nullish(),
});
export type Profile = z.infer<typeof Profile>;

export type RegisteredUser = {
	id: string;
	email: string;
	registrationStatus: "OnBoarding" | "Completed";
};
